<template>
    <div
        id="lt-yantr"
        class="advanced-calc business-loan-calc">
        <div class="container-width">
            <div class="advanced-calc-filter">
                <div class="business-loan-information">
                    <label class="filter-header">Business information</label>
                    <ul class="filter-inputs three-col mob-ai-baseline">
                        <li class="business-start-date">
                            <label>{{ labelBusinessStartDate }}</label>
                            <drop-down
                                v-model="BusinessStartMonth"
                                :options="MonthList"
                                @input="calculateBusinessLoan()"
                            />
                            <drop-down
                                v-model="BusinessStartYear"
                                :options="YearList"
                                @input="calculateBusinessLoan()"
                            />
                        </li>
                        <li>
                            <number-input
                                v-model="AnnualRevenue"
                                :label="labelAnnualRevenue"
                                inputmode="decimal"
                                @input="calculateBusinessLoan()"
                            />
                        </li>
                        <li>
                            <drop-down
                                v-model="CreditScore"
                                :label="labelCreditScore"
                                :options="CreditScoreList"
                                @input="calculateBusinessLoan()"
                            />
                            <a
                                href="/redirect/offers?id=calc-fcs"
                                class="font-sm">Get your credit score</a>
                        </li>
                    </ul>
                    <label class="filter-header">Existing loan information <lt-label :tooltip-link="tooltipExistingLoan" /></label>
                    <ul class="filter-inputs three-col">
                        <li>
                            <number-input
                                v-model="StartingLoanBalance"
                                :label="labelStartingLoanBalance"
                                inputmode="decimal"
                                @input="checkLoanRepayment()"
                            />
                        </li>
                        <li>
                            <drop-down
                                v-model="LoanTerm"
                                :label="labelLoanTerm"
                                :options="LoanTermInMonthsList"
                                @input="calculateBusinessLoan()"
                            />
                        </li>
                        <li class="total-loan-repayment">
                            <number-input
                                v-model="LoanRepayment"
                                :label="labelTotalLoanRepayment"
                                :tooltip-link="tooltipTotalLoanRepayment"
                                inputmode="decimal"
                                @input="checkLoanRepayment()"
                            />
                            <span
                                v-show="ShowLoanRepaymentError"
                                class="error-msg">Enter loan repayment amount > ${{ formatAmount(formatFigure(StartingLoanBalance)) }}</span>
                            <a
                                href="javascript:void(0)"
                                class="reset-calc hidden-xs"
                                @click="resetCalculator()"><span class="lt-icons lt4-Refresh"></span> Reset Calculator</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="business-loan-rate-reduction">
                <h2>Your likelihood of a rate reduction is</h2>
                <h2 class="green-text">
                    {{ Output }}
                </h2>
                <div class="footer-section">
                    <button
                        class="btn btn-blue"
                        type="submit"
                        @click="redirect()">
                        {{ DestinationButtonText }}
                    </button>
                    <advertising-disclosures
                        v-if="DisclosureText"
                        :disclosure-text="DisclosureText"
                        :disclosure-tokens="DisclosureTokens"
                        class="disclosures"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import NumberInput from '~/components/number-input.vue';
    import DropDown from '~/components/drop-down.vue';
    import LoanTermList from '~/constants/loan-term-list';
    import CreditScoreList from '~/constants/credit-score-list';
    import MonthList from '~/constants/month-list';
    import DefaultTooltip from '~/constants/tooltip-defaults';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import BaseMixin from '~/mixin/base-mixin';
    import LtLabel from '~/components/lt-label.vue';

    export default {
        components: {
            NumberInput,
            DropDown,
            AdvertisingDisclosures,
            LtLabel,
        },
        mixins: [BaseMixin],
        props: {
            labelBusinessStartDate: {
                default: 'Business Start Date',
            },
            labelAnnualRevenue: {
                default: 'Annual Revenue',
            },
            labelCreditScore: {
                default: 'Est. Credit Score',
            },
            labelStartingLoanBalance: {
                default: 'Starting Loan Balance',
            },
            labelLoanTerm: {
                default: 'Loan Term',
            },
            labelTotalLoanRepayment: {
                default: 'Total Loan Repayment',
            },
            annualRevenue: {
                default: 300000,
            },
            tooltipDeposit: {
                default: 'current-balance',
            },
            creditScore: {
                default: '1',
            },
            destinationButtonText: {
                default: 'View Free Offers',
            },
            businessStartMonth: {
                default: new Date().getMonth() + 1,
            },
            businessStartYear: {
                default: new Date().getFullYear(),
            },
            disclosureTokens: {
                default: '01',
            },
            disclosureText: {
                default: 'Disclosures',
            },
            destinationLinkOrId: {
                default: 'LT-auto-calc',
            },
            loanRepayment: {
                default: 39000,
            },
            startingLoanBalance: {
                default: 30000,
            },
            loanTerm: {
                default: 12,
            },
            tooltipExistingLoan: {
                default: DefaultTooltip.ExistingLoanInformation,
            },
            tooltipTotalLoanRepayment: {
                default: DefaultTooltip.TotalLoanRepayment,
            },
        },
        data() {
            return {
                LoanTermInMonthsList: LoanTermList.BusinessRefinanceLoanTerms,
                CreditScoreList: CreditScoreList.businessLoanRefinance,
                AnnualRevenue: this.annualRevenue,
                CreditScore: this.creditScore,
                DestinationButtonText: this.destinationButtonText,
                BusinessStartMonth: this.businessStartMonth,
                MonthList,
                BusinessStartYear: this.businessStartYear,
                YearList: [],
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                DestinationLinkOrId: this.destinationLinkOrId,
                CurrentYear: new Date().getFullYear(),
                CurrentMonth: new Date().getMonth() + 1,
                LoanRepayment: this.loanRepayment,
                StartingLoanBalance: this.startingLoanBalance,
                LoanTerm: this.loanTerm,
                Output: '',
                ShowLoanRepaymentError: false,
                UpdatedLoanRepayment: this.loanRepayment,
            };
        },
        mounted() {
            this.calculateBusinessLoan();
        },
        created() {
            this.getYearList();
        },
        methods: {
            getTimeInBusinessFactor(timeInBusiness) {
                if (timeInBusiness === 0) {
                    return 0;
                }
                if (timeInBusiness <= 0.417) {
                    return 20.68;
                }
                if (timeInBusiness <= 0.917) {
                    return 36.55;
                }
                if (timeInBusiness < 2) {
                    return 53.34;
                }
                if (timeInBusiness < 5) {
                    return 56.66;
                }
                if (timeInBusiness >= 5) {
                    return 56.82;
                }
                return 0;
            },
            getCreditScoreFactor(creditScore) {
                if (creditScore === 1) {
                    return 24.82;
                }
                if (creditScore === 2) {
                    return 24.7;
                }
                if (creditScore === 3) {
                    return 23.04;
                }
                if (creditScore === 4) {
                    return 15.42;
                }
                return 0;
            },
            getAnnualRevenueFactor(annualRevenue) {
                if (annualRevenue < 50000) {
                    return 0.78;
                }
                if (annualRevenue < 100000) {
                    return 27.22;
                }
                if (annualRevenue < 250000) {
                    return 66.17;
                }
                if (annualRevenue < 500000) {
                    return 69.47;
                }
                if (annualRevenue < 100000000) {
                    return 71.24;
                }
                return 0;
            },
            getSnapScore(refinanceCalculation) {
                if (refinanceCalculation <= 500) {
                    return 'F';
                }
                if (refinanceCalculation <= 650) {
                    return 'E';
                }
                if (refinanceCalculation <= 750) {
                    return 'D';
                }
                if (refinanceCalculation <= 800) {
                    return 'C';
                }
                if (refinanceCalculation <= 850) {
                    return 'B';
                }
                if (refinanceCalculation <= 1000) {
                    return 'A';
                }
                return 'F';
            },
            getOutputValue(annualRate, snapScore) {
                if (annualRate < 0.1) {
                    return 'Unlikely';
                }
                if (annualRate < 0.15 && (snapScore === 'A' || snapScore === 'B')) {
                    return 'Low';
                }
                if (annualRate < 0.25 && (snapScore === 'A' || snapScore === 'B' || snapScore === 'C')) {
                    return 'Moderate';
                }
                if (annualRate < 0.35 && (snapScore === 'A' || snapScore === 'B' || snapScore === 'C' || snapScore === 'D')) {
                    return 'HIGH';
                }
                if (annualRate >= 0.35 && (snapScore === 'A' || snapScore === 'B' || snapScore === 'C' || snapScore === 'D' || snapScore === 'E')) {
                    return 'VERY HIGH';
                }
                return 'Unlikely';
            },
            calculateBusinessLoan() {
                const timeInBusiness = this.CurrentYear - this.BusinessStartYear + (this.CurrentMonth - this.BusinessStartMonth) / 12;
                const creditScore = Number(this.CreditScore);
                const annualRevenue = this.unformatFigure(this.AnnualRevenue);
                const refinanceCalculation = (this.getTimeInBusinessFactor(timeInBusiness) + this.getCreditScoreFactor(creditScore) + this.getAnnualRevenueFactor(annualRevenue)) / 0.1683;
                const snapScore = this.getSnapScore(refinanceCalculation);
                const annualRate = (this.UpdatedLoanRepayment - this.unformatFigure(this.StartingLoanBalance)) / (this.LoanTerm / 12) / this.unformatFigure(this.StartingLoanBalance);
                this.Output = this.getOutputValue(annualRate, snapScore);
            },
            getYearList() {
                for (let year = this.CurrentYear; year >= this.CurrentYear - 100; year--) {
                    this.YearList.push({
                        text: year,
                        value: year,
                    });
                }
            },
            formatAmount(figure) {
                return Accounting.formatNumber(figure);
            },
            resetCalculator() {
                this.BusinessStartMonth = this.businessStartMonth;
                this.BusinessStartYear = this.businessStartYear;
                this.AnnualRevenue = this.formatFigure(this.annualRevenue);
                this.StartingLoanBalance = this.formatFigure(this.startingLoanBalance);
                this.CreditScore = this.creditScore;
                this.LoanTerm = this.loanTerm;
                this.LoanRepayment = this.formatFigure(this.loanRepayment);
                this.UpdatedLoanRepayment = this.loanRepayment;
                this.ShowLoanRepaymentError = false;
                this.calculateBusinessLoan();
            },
            checkLoanRepayment() {
                if (this.unformatFigure(this.LoanRepayment) < this.unformatFigure(this.StartingLoanBalance)) {
                    this.ShowLoanRepaymentError = true;
                    this.UpdatedLoanRepayment = this.unformatFigure(this.StartingLoanBalance);
                } else {
                    this.ShowLoanRepaymentError = false;
                    this.UpdatedLoanRepayment = this.unformatFigure(this.LoanRepayment);
                }
                this.$nextTick(() => {
                    this.calculateBusinessLoan();
                });
            },
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="../../assets/styles/calc-advanced-filter.scss" lang="scss"></style>
<!-- Below main.scss file is common for "Business Loan & Business Loan Refinance" Calculator. -->
<style src="../business-loan/main.scss" lang="scss"></style>
